// /* eslint-disable no-underscore-dangle */
// /* eslint-disable no-unused-vars */
import React from 'react';
import { Tag, Space, Typography } from 'antd';
import EbzButton from 'components/EbzButton';
import currencyFormat from 'utils/currencyFormat';
import { INVOICE_STATUS, PAYOUT_REPORT_STATUS } from 'constants/status';
import dayjs from 'dayjs';
import './PayoutReportsListPage.scss';

const PARTNER_INVOICE_PENDING = 'PARTNER_INVOICE_PENDING';
const PARTNER_INVOICE_ON_HOLD = 'ON_HOLD';
const PAYOUT_REPORT = 'PAYOUT_REPORT';
const BULK_INVOICE = 'BULK_INVOICE';
const TELLER_REDIRECT_URL = 'https://easebuzz.in/teller/';
const TELLER = 'TELLER';
const CONSENT = 'CONSENT';

const getColumns = (handleViewDetails, type) => {
  const renderDate = (date) => (date === null ? 'Invalid Date' : dayjs(date).format("DD MMM, 'YY"));
  const renderAmount = (amount) => (
    <Typography.Text style={{ wordSpacing: '12px' }}>
      {currencyFormat(amount, true, true)}
    </Typography.Text>
  );

  const commonColumns = [
    {
      title: <Space>Report Name</Space>,
      dataIndex: '_id',
      key: '_id',
      ellipsis: {
        showTitle: false
      }
    },
    {
      title: 'Generation Date',
      dataIndex: 'document_created_at',
      key: 'document_created_at',
      render: renderDate
    },
    {
      title: <Space>Invoice Amount</Space>,
      dataIndex: 'invoice_amount',
      key: 'invoice_amount',
      render: renderAmount
    }
  ];
  const payoutBulkColumns = [
    ...commonColumns,
    {
      title: <Space>Invoice Gst Amount</Space>,
      dataIndex: 'invoice_gst_amount',
      key: 'invoice_gst_amount',
      render: renderAmount
    },
    {
      title: <Space>Total Commission</Space>,
      dataIndex: 'final_commission_amount',
      key: 'final_commission_amount',
      render: renderAmount
    }
  ];
  const payoutReportColumns = [
    ...commonColumns,
    {
      title: 'Report Start Date',
      dataIndex: 'payout_start_date',
      key: 'payout_start_date',
      render: renderDate
    },
    {
      title: 'Report End Date',
      dataIndex: 'payout_end_date',
      key: 'payout_end_date',
      render: renderDate
    },
    {
      title: <Space>Invoice Status</Space>,
      dataIndex: 'invoice_status',
      key: 'invoice_status',
      align: 'center',
      render: (status) => {
        const statusInfo = INVOICE_STATUS[status];
        return statusInfo?.render;
      }
    },
    {
      title: <Space>Status</Space>,
      dataIndex: 'status',
      key: 'status',
      width: '200px',

      align: 'center',
      render: (status) => {
        const statusInfo = PAYOUT_REPORT_STATUS[status];
        return statusInfo ? (
          <Tag
            color={statusInfo?.bgColor}
            style={{ padding: '2px 13px', color: statusInfo?.color, fontSize: '12px' }}
          >
            {statusInfo?.label}
          </Tag>
        ) : (
          <Tag color="#EBEBEB" style={{ padding: '2px 13px', color: '#7B7B7B', fontSize: '12px' }}>
            {status}
          </Tag>
        );
      }
    },
    {
      title: <Space>Actions</Space>,
      align: 'center',
      render: (record) => (
        <EbzButton size="small" onClick={() => handleViewDetails(record)}>
          View Details
        </EbzButton>
      )
    }
  ];

  // Select columns based on the type argument
  if (type === PAYOUT_REPORT) {
    return payoutReportColumns;
  }
  if (type === BULK_INVOICE) {
    return payoutBulkColumns;
  }
  return [];
};

const BULK_INVOICE_SUMMARY_KEY = [
  { key: '_id', label: 'Partner ID' },
  { key: 'total_commission_amount', label: 'Total Commission Amount', prefix: '₹' },
  { key: 'total_gst_amount', label: 'Total GST Amount', prefix: '₹' },
  { key: 'total_invoice_amount', label: 'Total Invoice Amount', prefix: '₹' },
  { key: 'total_payout_count', label: 'Total Payout Count' },
  { key: 'account_no', label: 'Receiver Account Number' },
  { key: 'ifsc_code', label: 'Bank IFSC Code' },
  { key: 'name_on_bank', label: 'Receiver Bank Name' }
];
const getPayoutReportColumn = (handleViewDetails) => getColumns(handleViewDetails, PAYOUT_REPORT);
const getBulkInvoiceColumn = (handleViewDetails) => getColumns(handleViewDetails, BULK_INVOICE);

const TOUR_PAYOUT_REPORT_CONTENT = [
  {
    content: (
      <div>
        <h2>Welcome</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  },
  {
    title: 'Payout Reports',
    content: 'View and accept payouts',
    placement: 'bottom',
    target: '.payout-report-data'
  },
  {
    content: (
      <div>
        <h2>End</h2>
      </div>
    ),
    placement: 'center',
    target: 'body'
  }
];

export {
  getPayoutReportColumn,
  BULK_INVOICE_SUMMARY_KEY,
  PARTNER_INVOICE_PENDING,
  PARTNER_INVOICE_ON_HOLD,
  TELLER_REDIRECT_URL,
  TELLER,
  CONSENT,
  getBulkInvoiceColumn,
  TOUR_PAYOUT_REPORT_CONTENT
};
